import { useV2ListLobApprovalsForAccountQuery } from "@generated";
import type { LobApprovalRow, LobApprovalUserRow } from "../types/LobApproval";

export interface UseLobApprovalsListResult {
  rows: LobApprovalRow[];
  totalCount: number;
  isLoading: boolean;
  isFetching: boolean;
  refetch: () => void;
}

const extractApprovers = (
  record: any,
  included: any[]
): LobApprovalUserRow[] => {
  const refs = record.relationships?.["lob-approval-users"]?.data ?? [];
  return refs.map((ref: any) => {
    const userRecord = included.find(
      (i) => i.type === "lob-approval-users" && String(i.id) === String(ref.id)
    );
    const attrs = userRecord?.attributes ?? {};
    return {
      id: String(userRecord?.id ?? ref.id),
      userId: attrs["user-id"] != null ? String(attrs["user-id"]) : "",
      name: attrs.user?.name ?? "",
      requiredApprover: !!attrs["required-approver"],
    };
  });
};

export const useLobApprovalsList = (): UseLobApprovalsListResult => {
  const { data, isLoading, isFetching, refetch } =
    useV2ListLobApprovalsForAccountQuery({
      include: ["section", "lob-approval-users"],
    });
  const included: any[] = (data as any)?.included ?? [];

  const rows: LobApprovalRow[] =
    data?.data?.map((record: any) => ({
      id: String(record.id),
      sectionId: String(record.relationships?.section?.data?.id ?? ""),
      name: record.attributes.name ?? "",
      requiredApprovals: record.attributes["required-approvals"] ?? 0,
      submitterMayApprove: !!record.attributes["submitter-may-approve"],
      limitApprovalsToTeam: !!record.attributes["limit-approvals-to-team"],
      approvers: extractApprovers(record, included),
    })) ?? [];

  return {
    rows,
    totalCount: data?.meta?.["record-count"] ?? rows.length,
    isLoading,
    isFetching,
    refetch,
  };
};
